<app-leads-popup #leadsPopupRef [isFromService]="true" [isFromServiceOrder]="true" [soId]="dialogData.soId" [soldToBp]="dialogData.soldToBp" (openIscBpLookup)="onOpenIscBpLookup()"></app-leads-popup>

<app-config-advanced-search
  *ngIf="showIscBpLookup"
  [company]="company"
  [serviceDepartment]="serviceDepartment"
  (onClose)="onCloseSearchForCustomer($event)"
></app-config-advanced-search>
